<template>
  <v-container>
    <p v-if="!noDeviceType" class="primary--text text-center display-2">{{$t('DeviceTypes.title')}}</p>
    <br />
    <v-alert type="warning" v-if="ready && noDeviceType">{{$t('DeviceTypes.alert-nodeviceTypes')}}</v-alert>
    <template v-if="loading && !noDeviceType">
      <v-row justify="center">
        <v-col>
          <div class="text-center mt-5">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row>
        <v-col v-for="devType in deviceTypesArray" :key="devType.deviceTypeId" cols="12" sm="4">
          <v-hover v-slot:default="{ hover }">
            <v-card
              :id="devType.deviceTypeId"
              style="cursor: pointer;"
              :elevation="hover ? 10 : 2"
              class="mx-auto"
              max-width="344"
              @click="sendChoosenDeviceType($event)"
            >
              <v-list-item three-line>
                <v-list-item-content>
                  <div class="subtitle-2 mb-4 text-uppercase">{{devType.deviceTypeId}}</div>
                  <v-list-item-title class="headline mb-1">{{devType.name}}</v-list-item-title>
                  <v-list-item-subtitle>{{devType.description}}</v-list-item-subtitle>
                  <v-system-bar color="transparent">
                    <v-spacer></v-spacer>
                    <v-chip
                      v-for="scope in devType.scopes"
                      :key="scope"
                      class="mt-2 ml-1 mb-1"
                      :color="scopeColor(scope)"
                      text-color="white"
                      small
                    >{{scope}}</v-chip>
                  </v-system-bar>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import axios from "axios";
import tokenStore from "../../store/TokenStore";

export default {
  props: {
    source: String
  },
  data: () => ({
    userId: null,
    username: null,
    mail: null,
    deviceTypes: [],
    noDeviceType: true,
    ready: false,
    loading: true
  }),
  computed: {
    deviceTypesArray: function() {
      let array = this.deviceTypes;
      function compare(d1, d2) {
        let a = d1.name;
        let b = d2.name;
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
      }
      if (array != undefined) {
        return array.sort(compare);
      } else {
        return array;
      }
    }
  },
  watch: {
    deviceTypesArray: function() {
      this.loading = false;
    }
  },
  methods: {
    sendChoosenDeviceType: function(event) {
      let index = this.deviceTypes.findIndex(e => {
        return e.deviceTypeId == event.currentTarget.id;
      });
      this.$emit("choosendeviceType", this.deviceTypes[index]);
    },
    scopeColor: function(scope) {
      switch (scope) {
        default:
          return "primary";

        case "admin":
          return "red";

        case "creator":
          return "#981b00";
      }
    }
  },
  beforeMount: function() {
    axios
      .get(process.env.VUE_APP_API_ADDR + "/api/user/@me", {
        headers: { Authorization: tokenStore.getToken() }
      })
      .then(res => {
        if (res.data.user.permissions.deviceTypes.length == 0) {
          this.noDeviceType = true;
        } else {
          this.noDeviceType = false;
          this.mail = res.data.user.mail;
          this.username = res.data.user.username;
          this.userId = res.data.user.id;
          let $deviceTypes = res.data.user.permissions.deviceTypes;
          $deviceTypes.forEach(deviceType => {
            axios
              .get(
                process.env.VUE_APP_API_ADDR +
                  "/api/devicetype/" +
                  deviceType.deviceTypeId,
                {
                  headers: { Authorization: tokenStore.getToken() }
                }
              )
              .then(res => {
                deviceType.name = res.data.deviceType.name;
                deviceType.description = res.data.deviceType.description;
                deviceType.properties = res.data.deviceType.properties;
                this.deviceTypes.push(deviceType);
              })

              .catch(err => {
                console.log(err);
                tokenStore.refreshToken();
              });
          });
        }
        this.ready = true;
      })
      .catch(err => {
        console.log(err);
        tokenStore.refreshToken();
      });
  }
};
</script>
